module.exports = __webpack_public_path__ + "img/icon-payment-pse.fe9e99c6.svg";